import { Hammer } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const FrameStepPlaceholder = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-7 rounded-3xl border border-amber-300/50 bg-amber-50/80 px-10 py-16 text-center shadow-[0_30px_80px_-40px_rgba(245,158,11,0.55)] dark:border-amber-200/30 dark:bg-amber-950/30 dark:shadow-[0_30px_80px_-40px_rgba(245,158,11,0.35)]">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/15 text-amber-600 dark:bg-amber-400/15 dark:text-amber-300">
        <Hammer className="h-7 w-7" aria-hidden="true" />
      </div>

      <div className="space-y-4">
        <h2 className="text-2xl font-semibold tracking-tight text-amber-800 dark:text-amber-100">
          {t('canvas.frame.unavailableTitle', 'Frames are coming soon')}
        </h2>
        <p className="text-base leading-relaxed text-amber-900/80 dark:text-amber-100/80">
          {t(
            'canvas.frame.unavailableBody',
            'Place your art print order without a frame today—we will let you know the moment framing options launch.',
          )}
        </p>
      </div>

    </div>
  );
};

export default FrameStepPlaceholder;
